const baseURL = "http://www.fredjely.com";

export default baseURL;